var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwipeRightOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 73,
    viewBox: "0 0 53 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        opacity: 0.5;\r\n      }\r\n\r\n      .cls-2, .cls-5 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #586f93;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #586f93;\r\n        font-size: 52px;\r\n        font-family: Poppins-Medium, Poppins;\r\n        font-weight: 500;\r\n        letter-spacing: 0.1em;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    className: "cls-1",
    transform: "translate(53.218 0) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    className: "cls-2",
    transform: "translate(10 0.218)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 26.5,
    cy: 26.5,
    r: 26.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 26.5,
    cy: 26.5,
    r: 26
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": ">",
    className: "cls-3",
    transform: "matrix(0, -1, -1, 0, 18, 41.218)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&gt;")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipeRightOutlined);
export default __webpack_public_path__ + "static/media/Swipe-Right-Outlined.11405d9d8f7e45ecc520c1bb632b4f00.svg";
export { ForwardRef as ReactComponent };